export default function ListItemNoData() {
  return (
    <div className="flex flex-col items-center">
      <p className="text-lg font-bold">データが見つかりませんでした</p>
      <p className="mt-2 text-base">他の条件で再度お探しください。</p>
      <img
        src="/agent/job_change_processes/no-data.svg"
        width={217}
        height={210}
        alt=""
        className="mt-8"
      />
    </div>
  );
}
